import * as types from "../../actions/ActionTypes";

const initialState = {
    loading: false,
    data: null,
    error: null,
};

const globalFeedCreationReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.GLOBAL_FEED_CREATION_START:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case types.GLOBAL_FEED_CREATION_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null,
            };

        case types.GLOBAL_FEED_CREATION_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        case types.GLOBAL_FEED_CREATION_RESET:
            return initialState;

        default:
            return state;
    }
};

export default globalFeedCreationReducer;
